import type { BlogPost } from '@/features/blog/data'
import { BlogCard } from './card'

interface BlogPostListProps {
  posts: BlogPost[]
}

export function BlogPosts({ posts }: BlogPostListProps) {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post) => (
        <BlogCard key={post.slug} post={post} />
      ))}
    </div>
  )
}
